var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "delivery-tab-layout",
    {
      staticClass: "delivery-courier-tab",
      attrs: { loading: _vm.loading },
      scopedSlots: _vm._u([
        {
          key: "aside",
          fn: function() {
            return [
              _c(
                "vue-client-only",
                [
                  _vm.adaptive.isDesktop
                    ? _c("stores-map", {
                        staticClass: "delivery-courier-tab__map",
                        attrs: {
                          "current-local-city": _vm.currentCity,
                          "active-store-id": "activePointId",
                          stores: _vm.geoPoints
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._t("default"),
      _vm.isDeliveryAvailable
        ? [
            _c(
              "div",
              { staticClass: "delivery-courier-tab__subtitle" },
              [
                _c("span", [_vm._v("Куда доставить заказ")]),
                _c(
                  "products-count-tag",
                  _vm._b({}, "products-count-tag", _vm.productsCount, false)
                )
              ],
              1
            ),
            _c("delivery-address-form", {
              staticClass: "delivery-courier-tab__address-form",
              attrs: {
                "delivery-price": _vm.deliveryPrice,
                "current-city": _vm.currentCity
              },
              on: { change: _vm.onChangeAddress, save: _vm.onSaveAddress }
            })
          ]
        : _c(
            "page-info",
            {
              staticClass: "delivery-tab-layout__stub",
              attrs: { title: "Доставить курьером невозможно" }
            },
            [
              _vm._v("\n    Выберите удобный пункт\n    "),
              _c(
                "span",
                {
                  on: {
                    click: function($event) {
                      return _vm.$emit("change-view", "pickup")
                    }
                  }
                },
                [_vm._v("самовывоза")]
              )
            ]
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }